// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, browser:true, react:true*/
import React, {Fragment, useContext, useEffect, useMemo, useRef,
    useState} from 'react';
import cn from 'classnames';
import {Button} from '../../lib/button';
import {Modal} from '../../lib/modal';
import {Payment_form} from '../../plus/payment_form_hola2023_theme';
import {Plans_as_boxes, i_plans_as_boxes_trans}
    from '../../plus/plans_as_boxes';
import {use_premium_page, use_premium_landing}
    from '../../ui/premium/use_premium_page';
import {Callback_provider, Settings_context} from '../../settings_ctx';
import plus_ui from '/www/hola/pub/plus_ui.js';
import {use_translation_v} from '../../lib/trans_v';
import {img_url} from '../../ui/img_url';
import {Spacer} from '../../ui/homepage/spacer';
import {Already_premium} from '../../plus/already_premium';
import experiment_init from '../../experiment_init';
import {perr} from 'hola_pub_util';
import Check_icon from '../../img/hola2023/icons/10/check.svg';
import {Highest_rated} from '../../ui/highest_rated';
import {Pricing_faq} from '../../ui/pricing_faq';
import styles from './premium_land2.module.less';
// @ts-ignore
import {get_price_plan} from '../../../../../svc/account/pub/membership';
// @ts-ignore
import {get_period_units} from '../../../../../svc/vpn/pub/common_ui.js';
// @ts-ignore
import {format_price} from '/util/country.js';
import {App_context} from 'hola_app_context';
import {use_qs_with_set} from '../../lib/use_qs';
import {Svg_img} from '../../ui/svg_img';

interface i_premium_land_translations_data {
    plans_as_boxes?: i_plans_as_boxes_trans;
}

type t_page = ReturnType<typeof use_premium_page>;
interface i_premium_page_props {
    page: t_page;
}
const summary_plan_names = {
    '3 years': '3 years plan',
    'year': '1 Year plan',
    'month': 'Monthly plan',
};
const Premium_bext = ({page}: i_premium_page_props)=>{
    const {from_bext_qs, is_mobile, is_payment_form_open, opt,
        form_ref} = page;
    const {qs: {with_trial}} = use_qs_with_set();
    const {theme} = useContext(Settings_context);
    const summary_test = !is_mobile
      && !!experiment_init.ui_test.test_payment_page_order_summary;
    const secured_elems_test =
      !!experiment_init.ui_test.test_secured_elements_premium_checkout;
    const [with_skeleton, set_with_skeleton] = useState(true);
    const clear_skeleton_state = useMemo(()=>{
        let timeout_clean;
        return {
            remove: ()=>{
                clearTimeout(timeout_clean);
                timeout_clean = setTimeout(()=>{
                    const els = document
                      .getElementsByClassName('for_no_shadow_class');
                    if (els[0])
                        els[0].classList.remove('global_no_shadow');
                    if (from_bext_qs)
                        perr({id: 'www_payment_form_rendered'});
                }, 1000);
            },
            add: ()=>{
                clearTimeout(timeout_clean);
            },
        };
    }, []);
    const {price, discount, discount_percent, regular_price, month_price,
        every} = get_price_plan(opt.plan, opt.currency);
    const plan_months = get_period_units(opt.plan.period).months;
    const price_string = format_price(opt.currency, price);
    const month_price_string = format_price(opt.currency, month_price||price);
    const is_month_plan = opt.plan.every == 'month';
    useEffect(()=>{
        if (experiment_init.ui_test.test_skeleton)
            return;
        // @ts-ignore
        const connection = navigator.connection || navigator.mozConnection
          // @ts-ignore
          || navigator.webkitConnection;
        if (connection && connection.downlink>=7)
        {
            set_with_skeleton(false);
            const els = document.getElementsByClassName('for_no_shadow_class');
            if (els[0])
                els[0].classList.remove('global_no_shadow');
        }
    }, []);
    const title_font = summary_test ? cn(theme.p2, theme.bold)
        : cn(theme.p1, theme.med);
    return <Callback_provider fn={clear_skeleton_state}>
      <div className={cn(
        styles.with_title,
        !summary_test ? styles.root_in_iframe : styles.root_with_summary,
        secured_elems_test && styles.secured_elems_test,
        with_skeleton && 'hidden_element_for_fast_network')}
        id={'hidden_element_for_fast_network'}>
        {summary_test && <div className={styles.summary_side}>
          <div className={styles.summary}>
            <img className={styles.logo} src={img_url('hola_logo_letters.svg')}
              alt="Hola logo"/>
            <div className={styles.advantages_block}>
              <div className={styles.plan_container}>
                <img alt="rectangle" className="lazyload"
                  src={'https://hola.org/cms/wp-content/'+
                    'uploads/2024/02/Rectangle-2918.png'}/>
                <div className={styles.plan_title_container}>
                  <p className={cn(theme.p2, theme.bold, styles.neutrals700)}>
                    Hola Premium</p>
                  <p className={cn(theme.p3, theme.med)}>
                    {summary_plan_names[opt.plan.every] || opt.plan.name}</p>
                </div>
              </div>
              <div className={styles.advantages}>
                <div className={styles.advantage}>
                  <div className={styles.advantage_icon1}><Check_icon/></div>
                  <p className={cn(theme.p3, theme.med, styles.neutrals700)}>
                    No more time limits!</p>
                </div>
                <div className={styles.advantage}>
                  <div className={styles.advantage_icon2}><Check_icon/></div>
                  <p className={cn(theme.p3, theme.med, styles.neutrals700)}>
                    Use on up to 10 devices</p>
                </div>
                <div className={styles.advantage}>
                  <div className={styles.advantage_icon3}><Check_icon/></div>
                  <p className={cn(theme.p3, theme.med, styles.neutrals700)}>
                    Super fast HD streaming</p>
                </div>
                <div className={styles.advantage}>
                  <div className={styles.advantage_icon4}><Check_icon/></div>
                  <p className={cn(theme.p3, theme.med, styles.neutrals700)}>
                    Use on individual tabs</p>
                </div>
                <div className={styles.advantage}>
                  <div className={styles.advantage_icon5}><Check_icon/></div>
                  <p className={cn(theme.p3, theme.med, styles.neutrals700)}>
                    Available in incognito mode</p>
                </div>
              </div>
            </div>
            <p className={cn(theme.p2, theme.bold, styles.neutrals700,
              styles.summary_title)}>
              Order summary</p>
            {!is_month_plan && <div className={styles.summary_details}>
              <div className={styles.summary_line}>
                <p className={cn(theme.p3, theme.reg, styles.neutrals700)}>
                  Original price</p>
                <p className={cn(theme.p3, theme.reg, styles.neutrals700)}>
                  {format_price(opt.currency, regular_price)}
                </p>
              </div>
              {!!discount && <div className={styles.summary_line}>
                <p className={cn(theme.p3, theme.bold, styles.neutrals700)}>
                  Discount</p>
                <div className={styles.discount_container}>
                  <div className={styles.discount}>
                    <p className={cn(theme.p4, theme.bold)}>
                      {discount_percent}% OFF</p>
                  </div>
                  <p className={cn(theme.p3, theme.reg, styles.neutrals700)}>
                    -{format_price(opt.currency, discount)}</p>
                </div>
              </div>}
              <div className={styles.separator}/>
              <div className={styles.total_price_container}>
                <p className={cn(theme.p3, theme.reg, styles.neutrals700)}>
                  Order total</p>
                <div>
                  <p className={cn(theme.p3, theme.reg, styles.neutrals700,
                    styles.total_price)}>
                    {month_price_string} x {plan_months||1}
                    {plan_months ? 'months' : every}
                    = {price_string}</p>
                  <p className={cn(theme.p5, theme.reg, styles.billed_as)}>
                    (billed as one payment)</p>
                </div>
              </div>
            </div>}
            {is_month_plan && <div className={styles.monthly_summary_details}>
              <div className={cn(styles.summary_line,
                styles.month_plan_title)}>
                <p className={cn(theme.p3, theme.med, styles.neutrals700)}>
                  Hola Premium - Monthly</p>
              </div>
              <div className={cn(styles.summary_line, styles.monthly_total)}>
                <p className={cn(theme.p3, theme.reg, styles.neutrals700)}>
                  Order total</p>
                <p className={cn(theme.p3, theme.reg, styles.neutrals700)}>
                  {price_string}</p>
              </div>
              <div className={styles.separator}/>
            </div>}
            <div className={styles.separator}/>
            <div className={styles.promo_container}>
              <plus_ui.Checkout_promo {...opt} summary_test={summary_test}/>
            </div>
            <div className={styles.separator}/>
          </div>
        </div>}
        <div className={cn(!summary_test ? theme.container
          : styles.form_side)}>
          <div className={styles.with_form} ref={form_ref} key={'form'}>
            <p className={cn(styles.title_form, title_font)}>
              Checkout</p>
            {secured_elems_test &&
            <p className={cn(styles.title_secure, theme.p3, theme.med)}>
              <Svg_img id={'hola2023/icons/24/lock.svg'} w={24} h={24}/>
              Your payment is secured and end-to-end encrypted</p>}
            <Payment_form visible={is_payment_form_open} opt={opt}
              cls={cn(styles.inline_payment_form, 'for_no_shadow_class')}
              summary_test={summary_test}
              with_skeleton={with_skeleton}
              secured_elems_test={secured_elems_test}
              all_plans_test={true}
              with_trial={!!with_trial}
              payment_btn_on_top
              on_click={ev=>{
                ev.stopPropagation();
                // XXX: for closing all popups and selects
                document.body.click();
              }}
              on_load={()=>perr({id: 'www_payment_form_ready'})}/>
          </div>
        </div>
      </div>
    </Callback_provider>;
};

const Land_v1 = ({page}: i_premium_page_props)=>{
    const {form_ref, has_form, min_price_formatted, ref, plan_id, open_form,
        currencies, from_bext_qs, currency, set_plan, plans, plan} = page;
    const {theme} = useContext(Settings_context);
    const {t} = use_translation_v({version: 0});
    const starting_at_text = t('premium.starting_at', {min_price_formatted});
    const {plans_as_boxes} = t('premium.plans',
        {returnObjects: true})||{} as i_premium_land_translations_data;
    const features = useMemo(()=>{
        return ['unlimited', 'devices', 'fast', 'global', 'hd', 'more']
            .map(id=>({
                id,
                title: `premium.features.items.${id}`,
                img: img_url(`plus/premium_${id}.svg`),
            }));
    }, []);
    return <div className={styles.root}>
      {has_form && <div className={styles.with_form} ref={form_ref}
        key={'form'} id={'form_id'}>
        <iframe src={`/only_payment_form?ref=${ref}&plan=${plan}`+
          `&plan_id=${plan_id}${from_bext_qs ? '&holaext=1' : ''}`}/>
      </div>}
      <div className={cn(theme.container)}>
        <div className={styles.hero}>
          <h4 className={cn(theme.primary, styles.hero_subtitle)}>
            {t('premium.hero.subtitle')}</h4>
          <h2 className={cn(theme.primary, styles.hero_title)}>
            {t('premium.hero.title')}</h2>
          <p className={cn(theme.u2, styles.hero_text)}>
            {t('premium.hero.text')}</p>
          <Button caption={starting_at_text} arrow size={'lg'}
            txt_colored on_click={()=>{ open_form(); }}
            cls={styles.hero_btn}/>
        </div>
        <div className={cn(theme.block, styles.features)}>
          <h4 className={styles.features_title}>
            {t('premium.features.title')}</h4>
          <div className={styles.features_list}>
            {features.map(({id, title, img})=>{
                return <div key={id}
                  className={cn(styles.feature, styles[id])}>
                  <img src={img} alt="features" className="lazyload"/>
                  <p className={cn(theme.u3, theme.primary)}>{t(title)}</p>
                </div>;
            })}
          </div>
          <Button caption={starting_at_text} arrow size={'lg'} txt_colored
            on_click={()=>{ open_form(); }} cls={styles.features_btn}/>
        </div>
      </div>
      <div className={cn(theme.block, styles.plans_wrapper)}>
        <div className={theme.container}>
          {plans && <Plans_as_boxes key={'third_land'}
            plans={plans} currencies={currencies} currency={currency}
            set_plan={set_plan} trans={plans_as_boxes||{}}
            open_payment_form={()=>{ open_form(); }}
            class_name={styles.block}/>}
        </div>
      </div>
      <Spacer/>
    </div>;
};

const ic_x = <Svg_img id={'hola2023/icons/16/x_close.svg'} w={16} h={16}/>;
const ic_v = <Svg_img id={'hola2023/icons/16/check.svg'} w={16} h={16}/>;
const compare_table = [
    ['Watch time', 'Limited', 'Unlimited'],
    ['Number of countries', 'Limited', '+195 countries'],
    ['Access to websites', 'Limited', 'Unlimited'],
    ['Number of devices', '1', 'Up to 10'],
    ['Incognito mode', ic_x, ic_v],
    ['Video quality', 'Standard', 'High'],
    ['Connection Speed', 'Standard', 'Fast'],
    ['Individual tabs', ic_x, ic_v],
    ['Timer', 'Mandatory', 'Optional'],
    ['Connection optimization', ic_x, ic_v],
];
interface i_cmp_table_props {
    btn_title: string;
    on_click: ()=>void;
}
const Cmp_wide = (props: i_cmp_table_props)=>{
    const {btn_title, on_click} = props;
    const {theme} = useContext(Settings_context);
    const data = useMemo(()=>compare_table.reduce((acc, v)=>{
        acc.features.push(v[0]);
        acc.free.push(v[1]);
        acc.premium.push(v[2]);
        return acc;
    }, {features: [], free: [], premium: []}), []);
    const {features, free, premium} = data;
    return <div className={styles.cmp_wide_wrapper}>
      <div className={styles.cmp_wide}>
        <div className={cn(styles.col, styles.features_col)}>
          {features.map((v, i)=><p key={i}
            className={cn(theme.p3, theme.med, styles.line)}>{v}</p>)}
        </div>
        <div className={cn(styles.col, styles.free_col)}>
          <p className={cn(theme.bold, styles.col_title)}>Hola Free</p>
          {free.map((v, i)=><p key={i}
            className={cn(theme.p3, theme.med, styles.line)}>{v}</p>)}
        </div>
        <div className={cn(styles.col, styles.premium_col)}>
          <p className={cn(theme.bold, styles.col_title)}>Hola Premium</p>
          {premium.map((v, i)=><p key={i}
            className={cn(theme.p3, theme.med, styles.line)}>{v}</p>)}
          <div className={styles.cmp_cta}>
            <Button caption={btn_title} arrow size={'md'}
              txt_colored on_click={on_click}/>
          </div>
        </div>
      </div>
    </div>;
};
const Cmp_mobile = (props: i_cmp_table_props)=>{
    const {btn_title, on_click} = props;
    const {theme} = useContext(Settings_context);
    return <div className={cn(styles.cmp_mobile)}>
      <div className={styles.header}>
        <div className={styles.free_text}>
          <p className={theme.bold}>Hola <br/>Free</p>
        </div>
        <div className={styles.prem_text}>
          <p className={theme.bold}>Hola <br/>Premium</p>
        </div>
      </div>
      {compare_table.map(([feat, free, prem], i)=>{
          return <div key={i} className={styles.feat}>
            <p className={cn(theme.p3, theme.med)}>{feat}</p>
            <div className={styles.line}>
              <div className={styles.free_text}>
                <p className={cn(theme.p3, theme.med)}>{free}</p>
              </div>
              <div className={styles.prem_text}>
                <p className={cn(theme.p3, theme.med)}>{prem}</p>
              </div>
            </div>
          </div>;
      })}
      <Button caption={btn_title} arrow size={'md'} cls={styles.cmp_cta}
        txt_colored on_click={on_click}/>
    </div>;
};
const Cmp_table = (props: i_cmp_table_props)=>{
    return <div className={styles.cmp_table}>
      <Cmp_wide {...props}/>
      <Cmp_mobile {...props}/>
    </div>;
};
const Land_v2 = ({page}: i_premium_page_props)=>{
    const {form_ref, has_form, min_price_formatted, ref, plan_id, open_form,
        currencies, from_bext_qs, currency, set_plan, plans, plan} = page;
    const {theme} = useContext(Settings_context);
    const {is_client} = useContext(App_context);
    const root_ref = useRef<HTMLDivElement>();
    const portal_ref = useRef<HTMLDivElement>();
    const gradient_ref = useRef<HTMLDivElement>();
    const {t, T} = use_translation_v({version: 0});
    use_premium_landing(root_ref.current, portal_ref.current,
        gradient_ref.current);
    const starting_at_text = t('premium.starting_at', {min_price_formatted});
    const upgrade_to_text = t('premium.upgrade_to', {min_price_formatted});
    const {plans_as_boxes} = t('premium.plans',
        {returnObjects: true})||{} as i_premium_land_translations_data;
    const features = useMemo(()=>{
        return ['unlimited', 'devices', 'fast', 'global', 'hd', 'more']
            .map(id=>({
                id,
                title: `premium.features.items.${id}`,
                img: img_url(`plus/premium_${id}.svg`),
            }));
    }, []);
    const qa = useMemo(()=>[
        {trans: {q: 'qa.which_plan.q', a: 'qa.which_plan.a.2'}},
        {trans: {q: 'qa.pricing_how.q', a: 'qa.pricing_how.a.2'}},
        {trans: {q: 'qa.change_my_mind.q', a: 'qa.change_my_mind.a.2'}},
        {trans: {q: 'qa.change_my_plan.q', a: 'qa.change_my_plan.a.2'}},
        {trans: {q: 'qa.manage_billing.q', a: 'qa.manage_billing.a.2'}},
    ], []);
    const portal_cls = cn(styles.portal);
    const gradient_cls = cn(styles.gradient);
    const [inited, set_inited] = useState(false);
    const cls = cn(styles.root, styles.root_v2, {[styles.inited]: inited});
    useEffect(()=>{
        is_client && document.body.scrollIntoView();
        if (!has_form)
            set_inited(true);
    }, [is_client]);
    return <div className={cls} ref={root_ref}>
      {has_form && <div className={styles.with_form} ref={form_ref}
        key={'form'} id={'form_id'}>
        <iframe src={`/only_payment_form?ref=${ref}&plan=${plan}`+
          `&plan_id=${plan_id}${from_bext_qs ? '&holaext=1' : ''}`}/>
      </div>}
      <div className={portal_cls} ref={portal_ref}>
        <Svg_img id={'hola2023/premium_portal.svg'} /></div>
      <div className={gradient_cls} ref={gradient_ref}>
        <img src={img_url('hola2023/premium_gradient.png')} alt="gradient"
          className="lazyload"/>
      </div>
      <div id="hero" className={cn(theme.container, styles.slide)}>
        <div className={styles.slide_content}>
          <div className={styles.hero}>
            <h3 className={cn(theme.primary, styles.hero_subtitle)}>
              {t('premium.hero.subtitle')}</h3>
            <h1 className={cn(theme.primary, styles.hero_title)}>
              {t('premium.hero.title')}</h1>
            <p className={cn(theme.u2, styles.hero_text)}>
              {t('premium.hero.text')}</p>
            <Button caption={upgrade_to_text} arrow size={'lg'}
              txt_colored on_click={()=>{ open_form(); }}
              cls={styles.hero_btn}/>
          </div>
        </div>
      </div>
      <div id="promo1" className={cn(theme.container, styles.slide)}>
        <div className={styles.slide_content}>
          <div className={styles.hero}>
            <h2 className={cn(theme.primary, theme.H1, styles.hero_title)}>
              {t('premium.promo1.title')}</h2>
            <p className={cn(theme.u1, styles.hero_text)}>
              <T components={{br: <br/>}} i18nKey="premium.promo1.text"/>
            </p>
            <Button caption={upgrade_to_text} arrow size={'lg'}
              txt_colored on_click={()=>{ open_form(); }}
              cls={styles.hero_btn}/>
          </div>
        </div>
      </div>
      <div id="features" className={cn(theme.container, styles.slide)}>
        <div className={styles.slide_content}>
          <div className={cn(theme.block, styles.features)}>
            <h4 className={styles.features_title}>
              {t('premium.features.title')}</h4>
            <div className={styles.features_list}>
              {features.map(({id, title, img})=>{
                  return <div key={id}
                    className={cn(styles.feature, styles[id])}>
                    <img src={img} alt="features" className="lazyload"/>
                    <p className={cn(theme.u3, theme.primary)}>{t(title)}</p>
                  </div>;
              })}
            </div>
            <Button caption={upgrade_to_text} arrow size={'lg'} txt_colored
              on_click={()=>{ open_form(); }}
              cls={styles.features_btn}/>
          </div>
        </div>
      </div>
      <div id="reviews" className={cn(styles.slide)}>
        <div className={styles.slide_content}>
          <Highest_rated cls={cn(theme.block)} colored mode="info" ladder
            arrows fetch_at_once hide_info/>
        </div>
      </div>
      <div id="compare" className={cn(styles.compare_wrapper, styles.slide)}>
        <div className={styles.slide_content}>
          <div className={cn(theme.container, styles.compare)}>
            <h4 className={styles.compare_title}>Free vs Premium</h4>
            <p className={cn(theme.p1, styles.compare_subtitle)}>You are 100%
              backed by our money back policy</p>
            <Cmp_table btn_title={t('Get Premium')}
              on_click={()=>{ open_form(); }}/>
          </div>
        </div>
      </div>
      <div id="qa" className={cn(styles.slide)}>
        <div className={styles.slide_content}>
          <Pricing_faq qa={qa} title="Got questions? Read on."
            visible cols={1} loc subtitle="Common questions people ask"/>
        </div>
      </div>
      <div id="plans" className={cn(theme.block, styles.plans_wrapper,
        styles.slide)}>
        <div className={styles.slide_content}>
          <div className={theme.container}>
            {plans && <Plans_as_boxes key={'third_land'}
              plans={plans} currencies={currencies} currency={currency}
              set_plan={set_plan} trans={plans_as_boxes||{}}
              open_payment_form={()=>{ open_form(); }}
              class_name={styles.block}/>}
          </div>
        </div>
      </div>
      <div id="promo2" className={cn(theme.container, styles.slide)}>
        <div className={styles.slide_content}>
          <div className={styles.hero}>
            <h2 className={cn(theme.primary, theme.H1, styles.hero_title)}>
              {t('premium.promo2.title')}</h2>
            <p className={cn(theme.u1, styles.hero_text)}>
              {t('premium.promo2.text')}</p>
            <Button caption={starting_at_text} arrow size={'lg'}
              txt_colored on_click={()=>{ open_form(); }}
              cls={styles.hero_btn}/>
          </div>
        </div>
      </div>
    </div>;
};

const Premium_land = ({page}: i_premium_page_props)=>{
    const {is_payment_form_open, close_form, already_plus, opt,
        close_already_plus, is_mobile} = page;
    const {is_client} = useContext(App_context);
    const {theme} = useContext(Settings_context);
    return <div className={theme.root}>
      {experiment_init.ui_test.test_premium_lp_v2
          ? <Land_v2 page={page}/>
          : <Land_v1 page={page}/>
      }
      <Modal is_open={is_payment_form_open && !already_plus}
        on_close={close_form} paddingless width={!is_client ? 0 :
        is_mobile ? 335 : 592}
        on_overlay_click={()=>undefined}
        cls={styles.modal_root} fixed_top={67}
        long_modal content_cls={styles.modal_content}>
        <Payment_form visible={is_payment_form_open}
          opt={opt} cls={styles.form_in_modal}
          all_plans_test={true}
          with_skeleton={!!experiment_init.ui_test.test_skeleton}
          payment_btn_on_top={true}/>
      </Modal>
      <Modal is_open={is_payment_form_open && already_plus}
        on_close={close_form} width={335} cls={theme.root}>
        <Already_premium on_click={close_already_plus}/>
      </Modal>
    </div>;
};

export const Root = ({from_bext}:{from_bext:boolean})=>{
    const page = use_premium_page({from_bext});
    const {from_bext_qs, opt} = page;
    if (!opt.plan)
        return <Fragment/>;
    if (from_bext_qs)
        return <Premium_bext page={page}/>;
    return <Premium_land page={page}/>;
};

Root.meta = {
    meta: {
        title: 'Subscribe to Hola Premium',
        canonical_url: 'https://hola.org/premium_land2',
    },
    ssr_force: true,
    no_ssr: false,
    translation: {enabled: true, detect_by_country: true,
        white_list: ['en', 'ru', 'es']},
    nosearch: true,
    default_theme: 'hola2023',
    headlogo: true,
    nav_opt: {transparent: 1},
};
